import React from "react";
import { Box, ImageLazy, Link, Span } from "@catchoftheday/cg-components";
import { APPLE_STORE_DOWNLOAD_IMG, GOOGLE_PLAY_DOWNLOAD_IMG } from "@onepass-app/consts";
import { Card } from "./Card";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var AppNudgeCard = function AppNudgeCard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      iosAppLink = _ref.iosAppLink,
      androidAppLink = _ref.androidAppLink;
  return ___EmotionJSX(Card, null, ___EmotionJSX(Box, {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "onePass.primary",
    p: "10px"
  }, ___EmotionJSX(Span, {
    textAlign: "center",
    lineHeight: "tight",
    fontWeight: "bold",
    fontSize: "xl"
  }, title), ___EmotionJSX(Span, {
    textAlign: "center",
    fontWeight: "semibold",
    mb: "12px"
  }, subtitle), ___EmotionJSX(Link, {
    title: "Download app from App Store",
    href: iosAppLink,
    mb: "12px"
  }, ___EmotionJSX(ImageLazy, {
    alt: "App Store Logo",
    src: APPLE_STORE_DOWNLOAD_IMG,
    width: "120px !important",
    height: "auto !important"
  })), ___EmotionJSX(Link, {
    title: "Download app from Google Play",
    href: androidAppLink
  }, ___EmotionJSX(ImageLazy, {
    alt: "Play Store Logo",
    src: GOOGLE_PLAY_DOWNLOAD_IMG,
    width: "135px !important",
    height: "auto !important"
  }))));
};